export class BenefitSectionModel {
  header: number;
  shortDesc: string;
  longDesc: string;
  linkDesc: string;
  image: string;
  shopLinkName: string;
  manageLinkName: string;

  constructor() {
    this.header = undefined;
    this.shortDesc = undefined;
    this.longDesc = undefined;
    this.linkDesc = undefined;
    this.image = undefined;
    this.shopLinkName = undefined;
    this.manageLinkName = undefined;
  }
}
